export default __webpack_public_path__ + "static/popup-pic-004-8684831eb6c1822b45db2c37cb2fe2be.jpg";